<ng-container *transloco="let t">
  <div class="d-flex justify-content-between align-items-md-center pb-4 flex-column-reverse flex-xxl-row">
    <ng-content select="[slot='leadingWidgets']"></ng-content>
    <div class="ms-0 ms-xxl-3 d-flex flex-column flex-xl-row">
      <div class="pb-3 pb-xxl-0">
        <ng-content select="[slot='trailingWidgets']"></ng-content>
      </div>
      @if (isXlsVisible) {
        <div class="pe-2 pb-3 pb-xxl-0">
          <app-rounded-button [label]="t('events.details.organiser.export.to.xls')"
                              [btnClass]="'rounded-button--button-black-solid'"
                              [isDisabled]="false" (onClick)="exportToXls()">
            <i class="bi bi-file-excel pe-2"></i>
          </app-rounded-button>
        </div>
      }
      @if (isPdfVisible) {
        <div class="pb-3 pb-xxl-0">
          <app-rounded-button [label]="t('app.common.export.to.pdf')"
                              [btnClass]="'rounded-button--button-black-solid'"
                              [isDisabled]="false" (onClick)="exportToPdf()">
            <i class="bi bi-file-pdf pe-2"></i>
          </app-rounded-button>
        </div>
      }
    </div>
  </div>
</ng-container>
